import { render, staticRenderFns } from "./luckyDetails.vue?vue&type=template&id=7beb3980&scoped=true&"
import script from "./luckyDetails.vue?vue&type=script&lang=js&"
export * from "./luckyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7beb3980",
  null
  
)

export default component.exports